import { useForm } from "react-hook-form";
import { DataContext } from 'providers/data';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from 'react';

import * as Regex from 'utils/validations';

import Input from 'components/views/form/Input';
import { Box, Modal, Typography } from '@mui/material';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcIturinCircle } from 'assets/icons/ic-iturin-circle.svg';

import { BoxModal, LinkExtermal } from './styles';

type Params = {
    open: boolean;
    handleClick: (value: boolean) => void;
    CHAVE_PAGAMENTO?: string;
    CD_FORMA_PAGAMENTO?: number;
    isExternal?: boolean;
    date?: string;
    type?: 'pix' | 'ticket';
    isLinkRef?: boolean;
}

type ParamsPaymentMethodTicket = {
    open: boolean;
    handleClick: (value: boolean) => void;
    handleConfirm: (value: boolean) => void;
}

export const ModalConfirmChange = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '5px',
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 2rem)', md: '31.25rem' },
                p: { xs: '1rem 1rem 1.8rem', md: '1.56rem 1.31rem' },
                border: '2px solid #0AA8E3',
            }}>
                <Box sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    height: '144px',
                    'svg': {
                        position: 'absolute',
                        right: { xs: '-30px', md: '0' },
                        height: { xs: '90px', md: '144px' },
                    }
                }}>
                    <Typography fontWeight={700} color='white'
                        sx={{
                            fontSize: { xs: '1.25rem', md: '1.8rem' },
                            width: { xs: '80%', md: '70%' },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1.2rem 0 .8rem',
                            border: '1.4px solid #0AA8E3',
                            backgroundColor: 'primary.light'
                        }}>
                        IMPORTANTE
                    </Typography>
                    <IcIturinCircle />
                </Box>
                <Typography fontWeight={700} padding='1.25rem 0' lineHeight='22px' textAlign='center' sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}>
                    Informações sobre Alteração de forma de pagamento:
                </Typography>
                <Box display='flex' padding='0 .5rem'>
                    <Typography fontSize='1rem' paddingRight='.5rem'>
                        &middot;
                    </Typography>
                    <Typography fontSize='1rem'>
                        O prazo para este tipo de alteração é de 30 a 60 dias;
                    </Typography>
                </Box>
                <Box display='flex' padding='1.3rem .5rem 2.75rem'>
                    <Typography fontSize='1rem' paddingRight='.5rem'>
                        &middot;
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px'>
                        Se houver boleto já emitido a alteração ocorrerá apenas para o próximo boleto.
                    </Typography>
                </Box>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '.93rem',
                    padding: { xs: '0', md: '0 2rem' },
                    'button': {
                        width: '100%',
                        boxShadow: 'none',
                        maxHeight: '2.5rem'
                    }
                }}>
                    <ButtonRectangle name='ALTERAR' onClick={() => handleClick(true)} />
                    <ButtonOutlined name='CANCELAR' onClick={() => handleClick(false)} />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalConfirmChangeDueDate = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '5px',
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 2rem)', md: '31.25rem' },
                p: { xs: '1rem 1rem 1.8rem', md: '1.56rem 1.31rem' },
                border: '2px solid #0AA8E3',
            }}>
                <Box sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    height: { xs: '90px', md: '144px' },
                    'svg': {
                        position: 'absolute',
                        right: { xs: '-30px', md: '0' },
                        height: { xs: '90px', md: '144px' },
                    }
                }}>
                    <Typography fontWeight={700} color='white'
                        sx={{
                            fontSize: { xs: '1.25rem', md: '1.8rem' },
                            width: { xs: '80%', md: '70%' },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1.2rem 0 .8rem',
                            border: '1.4px solid #0AA8E3',
                            backgroundColor: 'primary.light'
                        }}>
                        IMPORTANTE
                    </Typography>
                    <IcIturinCircle />
                </Box>
                <Typography fontWeight={700} lineHeight='22px' textAlign='center' sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, padding: { xs: '.5rem 0 1.25rem', md: '1.25rem 0' } }}>
                    Informações sobre Alteração de forma de pagamento:
                </Typography>

                <Box sx={{ margin: '0 auto 1.875rem', maxWidth: '425px' }}>
                    <Box display='flex' padding='0 .5rem'>
                        <Typography paddingRight='.5rem' sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }} >
                            &middot;
                        </Typography>
                        <Typography sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }} >
                            O prazo para este tipo de alteração é de 30 a 60 dias;
                        </Typography>
                    </Box>
                    <Box display='flex' sx={{ padding: { xs: '.3rem .5rem 0', md: '1.3rem .5rem .5rem' } }}>
                        <Typography paddingRight='.5rem' sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }} >
                            &middot;
                        </Typography>
                        <Typography lineHeight='20px' sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }} >
                            Caso haja boletos em aberto, os mesmos deverão ser quitados;
                        </Typography>
                    </Box>
                    <Box display='flex' sx={{ padding: { xs: '.3rem .5rem 1.25rem', md: '1.3rem .5rem 1.56rem' } }}>
                        <Typography paddingRight='.5rem' sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }} >
                            &middot;
                        </Typography>
                        <Typography lineHeight='20px' sx={{ fontSize: { xs: '.875rem', md: '1rem' } }} >
                            De acordo com o ciclo de faturamento pode ocorrer a <br />
                            emissão de 2 boletos no mesmo mês após a alteração: <br />
                            um referente ao período de utilização atual e o outro referente ao período seguinte.
                        </Typography>
                    </Box>

                    <Typography lineHeight='20px' textAlign='center' sx={{ lineHeight: '1.2', fontSize: { xs: '.875rem', md: '1rem' } }}>
                        Vale lembrar que mesmo com essa alteração, no final do
                        período de 12 meses, você terá pago 12 mensalidades.
                    </Typography>
                </Box>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '.93rem',
                    padding: { xs: '0', md: '0 2rem' },
                    'button': {
                        width: '100%',
                        boxShadow: 'none',
                        maxHeight: '2.5rem'
                    }
                }}>
                    <ButtonRectangle name='ALTERAR' onClick={() => handleClick(true)} />
                    <ButtonOutlined name='CANCELAR' onClick={() => handleClick(false)} />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalConfirmedEmailExternal = ({ open, handleClick, CHAVE_PAGAMENTO, type, CD_FORMA_PAGAMENTO = 0 }: Params) => {
    const { register, watch, handleSubmit, setValue, formState: { errors } } = useForm();
    const [typeSelected, setTypeSelected] = useState('');
    const [successEmail, setSuccessEmail] = useState(false);
    const [isLoadingSendEmail, setIsLoadingSendEmail] = useState(false);
    const { dataGenerateBillingPix, dataGenerateBillingTicket, handlePostGenerateBilling } = useContext(DataContext);

    const email = watch('email');

    const handleSendTicketEmail = () => {
        if (!email.match(Regex.email)) {
            return;
        }

        if (CHAVE_PAGAMENTO && type) {
            setIsLoadingSendEmail(true);

            handlePostGenerateBilling({
                token: localStorage.getItem('token')!,
                body: { CHAVE_PAGAMENTO: CHAVE_PAGAMENTO, EMAIL: email, CD_FORMA_PAGAMENTO },
                type: type,
            });
        }
    }

    useEffect(() => {
        if (dataGenerateBillingPix?.EmailEnviado || dataGenerateBillingTicket?.EmailEnviado) {
            setSuccessEmail(true);
            setIsLoadingSendEmail(false);
        }
    }, [dataGenerateBillingTicket, dataGenerateBillingPix]);

    useEffect(() => {
        if (type && type !== typeSelected) {
            setTypeSelected(type);
            setValue('email', '');
            setSuccessEmail(false);
            setIsLoadingSendEmail(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    return (
        <Modal open={open} onClose={() => handleClick(false)}>
            <BoxModal sx={{ borderRadius: '8px', width: { xs: 'calc(100% - 2rem)', md: '24rem' } }} component='form' onSubmit={handleSubmit(handleSendTicketEmail)}>
                <Box sx={{ textAlign: 'center', padding: '1.625rem 1.5625rem .625rem' }}>
                    {successEmail ?
                        <Box>
                            <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                SUCESSO!
                            </Typography>
                            <Typography fontSize='1' paddingBottom='.625rem' lineHeight='17px'>
                                Enviamos o boleto para o seu e-mail.
                            </Typography>
                        </Box>
                        :
                        <Box>
                            <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                ENVIO POR E-MAIL!
                            </Typography>
                            <Typography fontSize='1' paddingBottom='.625rem' lineHeight='17px'>
                                Insira o e-mail para onde o {type === "pix" ? 'pix' : 'boleto'} será enviado:
                            </Typography>
                            <Box sx={{ marginBottom: '-1rem' }}>
                                <Input
                                    name='email'
                                    placeholder='Digite seu e-mail'
                                    type='text'
                                    label=''
                                    error={errors.email}
                                    textError='E-mail inválido'
                                    register={{ ...register("email", { pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}[\s]*$/i }) }}
                                />
                            </Box>
                        </Box>
                    }
                </Box>
                <Box sx={{
                    textAlign: 'center',
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '1.875rem 1.5625rem 1.875rem',
                    'button': {
                        width: '80%',
                        height: '2.5rem'
                    }
                }}>
                    <ButtonRectangle
                        name={successEmail ? 'CONTINUAR' : 'ENVIAR'}
                        loadingBtn={isLoadingSendEmail}
                        disabled={email ? false : true}
                        type='submit'
                        onClick={() => successEmail ? handleClick(false) : handleSendTicketEmail()}
                    />
                    {!successEmail &&
                        <Box sx={{
                            paddingTop: '.875rem',
                            'button': {
                                color: 'white',
                                borderColor: 'white',

                                '&:hover': {
                                    borderColor: 'white',
                                    opacity: '.8'
                                }
                            }
                        }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => handleClick(false)} />
                        </Box>
                    }
                </Box>
            </BoxModal>
        </Modal >
    );
}

export const ModalConfirmedChange = ({ open, handleClick, CHAVE_PAGAMENTO, type, CD_FORMA_PAGAMENTO = 0 }: Params) => {
    const { register, watch, handleSubmit, formState: { errors } } = useForm();
    const [typeSelected, setTypeSelected] = useState('');
    const [changedEmail, setChangedEmail] = useState(false);
    const [successEmail, setSuccessEmail] = useState(false);
    const [isLoadingSendEmail, setIsLoadingSendEmail] = useState(false);
    const { selectedCar, dataGenerateBillingPix, dataGenerateBillingTicket, handlePostGenerateBilling } = useContext(DataContext);

    const email = watch('email');

    const handleSendTicketEmail = () => {
        if (changedEmail && !email.match(Regex.email)) {
            return;
        }

        if (CHAVE_PAGAMENTO && type && errors) {
            setIsLoadingSendEmail(true);

            handlePostGenerateBilling({
                token: localStorage.getItem('token')!,
                body: { CHAVE_PAGAMENTO: CHAVE_PAGAMENTO, EMAIL: changedEmail ? email : selectedCar?.EMAIL, CD_FORMA_PAGAMENTO },
                type: type,
            });
        }
    }

    useEffect(() => {
        if (dataGenerateBillingPix?.EmailEnviado || dataGenerateBillingTicket?.EmailEnviado) {
            setSuccessEmail(true);
            setIsLoadingSendEmail(false);
        }
    }, [dataGenerateBillingTicket, dataGenerateBillingPix]);

    useEffect(() => {
        if (type && type !== typeSelected) {
            setTypeSelected(type);
            setChangedEmail(false);
            setSuccessEmail(false);
            setIsLoadingSendEmail(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    return (
        <Modal open={open} onClose={() => handleClick(false)}>
            <BoxModal sx={{ borderRadius: '8px', width: { xs: 'calc(100% - 2rem)', md: '24rem' } }} component='form' onSubmit={handleSubmit(handleSendTicketEmail)}>
                <Box sx={{ textAlign: 'center', padding: '1.625rem 1.5625rem .625rem' }}>
                    {successEmail ?
                        <Box>
                            <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                SUCESSO!
                            </Typography>
                            <Typography fontSize='1' paddingBottom='.625rem' lineHeight='17px'>
                                {type === 'pix' ? 'Enviamos o código QRCode para o seu email!' : 'Enviamos o boleto para o seu e-mail.'}
                            </Typography>
                        </Box>
                        :
                        changedEmail ?
                            <Box>
                                <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                    ENVIO POR E-MAIL!
                                </Typography>
                                <Typography fontSize='1' paddingBottom='.625rem' lineHeight='17px'>
                                    Digite o <strong>novo e-mail</strong> para o recebimento do
                                    seu boleto:
                                </Typography>
                                <Box sx={{ marginBottom: '-1rem' }}>
                                    <Input
                                        name='email'
                                        placeholder='Digite seu e-mail'
                                        type='text'
                                        label=''
                                        error={errors.email}
                                        textError='E-mail inválido'
                                        register={{ ...register("email", { pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}[\s]*$/i }) }}
                                    />
                                </Box>
                            </Box>
                            :
                            <Box>
                                <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                    CONFIRMAÇÃO DE E-MAIL!
                                </Typography>
                                <Typography fontSize='1rem' paddingBottom='.625rem' lineHeight='17px'>
                                    O seu e-mail cadastrado para recebimento do boleto é:
                                </Typography>
                                <Typography fontSize='1rem' fontWeight={700}>
                                    {selectedCar?.EMAIL}
                                </Typography>
                            </Box>
                    }
                </Box>
                <Box sx={{
                    textAlign: 'center',
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '1.875rem 1.5625rem 1.875rem',
                    'button': {
                        width: '80%',
                        height: '2.5rem'
                    }
                }}>
                    <ButtonRectangle
                        name={successEmail ? 'CONTINUAR' : changedEmail ? 'ENVIAR' : 'CONFIRMAR'}
                        loadingBtn={isLoadingSendEmail}
                        disabled={changedEmail ? email ? false : true : false}
                        type={changedEmail ? 'submit' : 'button'}
                        onClick={() => successEmail ? handleClick(false) : handleSendTicketEmail()}
                    />
                    {!successEmail &&
                        <Box sx={{
                            paddingTop: '.875rem',
                            'button': {
                                color: 'white',
                                borderColor: 'white',

                                '&:hover': {
                                    borderColor: 'white',
                                    opacity: '.8'
                                }
                            }
                        }}>
                            <ButtonOutlined name={changedEmail ? 'CANCELAR' : 'ALTERAR'} onClick={() => setChangedEmail(!changedEmail)} />
                        </Box>
                    }
                </Box>
            </BoxModal>
        </Modal >
    );
}

export const ModalConfirmChangeCreditCard = ({ open, handleClick, isExternal = false }: Params) => {
    const navigate = useNavigate();

    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 2rem)', md: '28rem' }
            }}>
                <Box sx={{ padding: '1.5rem 1.5rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        SUCESSO!
                    </Typography>
                    <Typography fontSize='1rem' fontWeight={600} lineHeight='20px' maxWidth='350px' margin='0 auto 1rem'>
                        Pagamento efetuado, o comprovante foi
                        enviado por e-mail.
                    </Typography>
                    <Typography fontSize='1rem' fontWeight={600} lineHeight='20px'>
                        Lembramos que pagamentos efetuados no cartão de crédito levam 24 horas úteis para baixa.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2.1875rem 0 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='CONTINUAR'
                        onClick={() => {
                            handleClick(false);
                            if (!isExternal) {
                                navigate('/faturas');
                            }
                        }}
                    />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalErrorCreditCard = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center'
            }}>
                <Box sx={{ padding: '1.5rem 2rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='1rem' fontWeight={600} lineHeight='20px'>
                        <strong style={{ color: '#FF0000' }}>
                            Cartão recusado!
                        </strong>
                        <br />
                        <br />
                        Reveja as informações ou adicione um <br />
                        outro cartão.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2.1875rem 0 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='VOLTAR'
                        onClick={() => handleClick(false)}
                    />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalSuccessBillingPaymentMethod = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '26rem' },
            }}>
                <Box sx={{ padding: '1.5rem 1rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        ALTERAÇÃO REALIZADA!
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                        <strong>
                            Em breve a sua solicitação será atendida.
                        </strong>
                        <br />
                        <br />
                        <strong>Importante:</strong> Enviamos no seu e-mail cadastrado as
                        informações sobre esta alteração.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2.1875rem 0 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='CONTINUAR'
                        onClick={() => handleClick(false)}
                    />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalErrorBillingPaymentMethod = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '20rem' },
            }}>
                <Box sx={{ padding: '1.5rem 2rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1rem' fontWeight={700} lineHeight='20px'>
                        Não foi possível concluir o processo no momento.
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                        Tente novamente mais tarde.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2.1875rem 3.81rem 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='FECHAR'
                        onClick={() => handleClick(false)}
                    />
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalErrorBillingPaymentMethodDeadline = ({ open, handleClick, date }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '22.5rem' },
            }}>
                <Box sx={{ padding: '1.56rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' fontWeight={700} textAlign='center'>
                        AVISO
                    </Typography>
                    <Typography fontSize='.875rem' lineHeight='19px' paddingTop='1rem' textAlign='center'>
                        Identificamos que você já realizou uma alteração de cobrança para este veículo{date && <> em <b style={{ color: '#0AA8E3' }}>{date}</b></>}.
                        <br />
                        <br />
                        Para solicitar uma nova alteração é necessário aguardar <b>60 dias</b> desde a última solicitação.
                        <br />
                        <br />
                        Para mais informações entrar em contato<br />
                        nos telefones:
                    </Typography>
                </Box>
                <Box
                    sx={{
                        padding: '1.8rem 1.2rem 2.2rem',
                        backgroundColor: 'primary.main',
                        borderRadius: '0 0 8px 8px',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                            '&#btn-outlined': {
                                borderColor: '#F9FCFF',
                                color: '#F9FCFF',
                                marginTop: '1rem'
                            }
                        }
                    }}>
                    <Typography fontSize='.875rem' color='white' paddingBottom='.9375rem' lineHeight='1.3'>
                        Atendimento de Segunda à Sexta das 08h as 18h e aos Sábados das 8h às 14h
                    </Typography>
                    <Box sx={{ maxWidth: '15rem', margin: '0 auto' }}>
                        <LinkExtermal href="tel:08007742000">
                            0800 774 2000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                        <LinkExtermal href="tel:551136169000">
                            3616 - 9000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                        <ButtonRectangle
                            name='FECHAR'
                            onClick={() => handleClick(false)}
                        />
                    </Box>
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalEmailBillingPaymentMethodTicket = ({ open, handleClick, handleConfirm }: ParamsPaymentMethodTicket) => {
    const { register, watch, handleSubmit, formState: { errors } } = useForm();
    const [changedEmail, setChangedEmail] = useState(false);
    const [enabledBtn, setEnabledBtn] = useState(false);
    const { selectedCar, dataCustomerForEdit, handlePostEditCustomerAppData, handleGetCustomerForEdit } = useContext(DataContext);

    const email = watch('email');

    const handleSendTicketEmail = () => {
        if (changedEmail && selectedCar && dataCustomerForEdit) {
            handlePostEditCustomerAppData({
                token: localStorage.getItem('token')!,
                body: {
                    id: selectedCar?.CD_PESSOA,
                    document: selectedCar?.NR_CNPJ_CPF,
                    email: email,
                    name: dataCustomerForEdit?.name,
                    userAlias: dataCustomerForEdit?.user?.username,
                    birthDate: dataCustomerForEdit?.birthDate,
                }
            })
        }

        handleConfirm(true);
        handleClick(false);
    }

    useEffect(() => {
        if (changedEmail) {
            if (email?.match(Regex.email)) {
                setEnabledBtn(false);
            } else {
                setEnabledBtn(true);
            }
        } else {
            setEnabledBtn(false);
        }
    }, [changedEmail, email]);

    useEffect(() => {
        if (!dataCustomerForEdit) {
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    return (
        <Modal open={open} onClose={() => handleClick(false)}>
            <BoxModal sx={{ borderRadius: '8px', width: { xs: 'calc(100% - 2rem)', md: '24rem' } }} component='form' onSubmit={handleSubmit(handleSendTicketEmail)}>
                <Box sx={{ textAlign: 'center', padding: '1.625rem 1.5625rem 1.8rem' }}>
                    {changedEmail ?
                        <Box>
                            <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                ENVIO POR E-MAIL!
                            </Typography>
                            <Typography fontSize='1' paddingBottom='.625rem' lineHeight='17px'>
                                Digite o <strong>novo e-mail</strong> para o recebimento do
                                seu boleto:
                            </Typography>
                            <Box sx={{ '#box-input': { height: 'fit-content' } }}>
                                <Input
                                    name='email'
                                    placeholder='Digite seu e-mail'
                                    type='text'
                                    label=''
                                    error={errors.email}
                                    textError='E-mail inválido'
                                    register={{ ...register("email", { pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}[\s]*$/i }) }}
                                />
                            </Box>
                        </Box>
                        :
                        <Box>
                            <Typography fontSize='1.5625rem' fontWeight={700} paddingBottom='1rem'>
                                CONFIRMAÇÃO DE E-MAIL!
                            </Typography>
                            <Typography fontSize='1rem' paddingBottom='.625rem' lineHeight='17px'>
                                O seu e-mail cadastrado para recebimento do boleto é:
                            </Typography>
                            <Typography fontSize='1rem' fontWeight={700}>
                                {selectedCar?.EMAIL}
                            </Typography>
                        </Box>
                    }
                </Box>
                <Box sx={{
                    textAlign: 'center',
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '1.875rem 1.5625rem 1.875rem',
                    'button': {
                        width: '80%',
                        height: '2.5rem'
                    }
                }}>
                    <ButtonRectangle
                        name={changedEmail ? 'ENVIAR' : 'CONFIRMAR'}
                        disabled={enabledBtn}
                        type={changedEmail ? 'submit' : 'button'}
                        onClick={() => handleSendTicketEmail()}
                    />
                    <Box sx={{
                        paddingTop: '.875rem',
                        'button': {
                            color: 'white',
                            borderColor: 'white',

                            '&:hover': {
                                borderColor: 'white',
                                opacity: '.8'
                            }
                        }
                    }}>
                        <ButtonOutlined name={changedEmail ? 'VOLTAR' : 'ALTERAR'} onClick={() => setChangedEmail(!changedEmail)} />
                    </Box>
                </Box>
            </BoxModal>
        </Modal >
    );
}

export const ModalPaymentMethodTicket = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '27rem' },
            }}>
                <Box sx={{ padding: '1.5rem 1rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                        Prezado cliente, sua fatura está em <b>débito em conta</b>,
                        deseja realmente emitir sua segunda via?
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2rem 0 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='CONTINUAR'
                        onClick={() => handleClick(true)}
                    />
                    <Box sx={{
                        paddingTop: '.875rem',
                        'button': {
                            color: 'white',
                            borderColor: 'white',

                            '&:hover': {
                                borderColor: 'white',
                                opacity: '.8'
                            }
                        }
                    }}>
                        <ButtonOutlined name='CANCELAR' onClick={() => handleClick(false)} />
                    </Box>
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalPaymentMethodTicketConfirm = ({ open, handleClick }: Params) => {
    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '27rem' },
            }}>
                <Box sx={{ padding: '1.5rem 1rem', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                        Afim de evitarmos <b>duplicidade de pagamento</b>, contate seu banco para cancelamento desta fatura.
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '2rem 0 1.875rem',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '15.68rem',
                    }
                }}>
                    <ButtonRectangle
                        name='CONTINUAR'
                        onClick={() => handleClick(true)}
                    />
                    <Box sx={{
                        paddingTop: '.875rem',
                        'button': {
                            color: 'white',
                            borderColor: 'white',

                            '&:hover': {
                                borderColor: 'white',
                                opacity: '.8'
                            }
                        }
                    }}>
                        <ButtonOutlined name='CANCELAR' onClick={() => handleClick(false)} />
                    </Box>
                </Box>
            </BoxModal>
        </Modal>
    );
}

export const ModalErrorPaymentKey = ({ open, isLinkRef = false, handleClick }: Params) => {
    const navigate = useNavigate();

    return (
        <Modal open={open}>
            <BoxModal sx={{
                borderRadius: '8px',
                textAlign: 'center',
                width: { xs: 'calc(100vw - 2rem)', md: '22rem' },
            }}>
                <Box sx={{ padding: '1.5rem 1rem 0', borderRadius: '8px 8px 0 0' }}>
                    <Typography fontSize='1.5625rem' paddingBottom='.75rem' fontWeight={700}>
                        ATENÇÃO!
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                        Prezado cliente, seu boleto não pôde ser gerado. Entre em contato com a nossa centra de atendimento:
                    </Typography>
                    <Box paddingTop='1rem' maxWidth='16rem' margin='0 auto'>
                        <LinkExtermal href="tel:08007742000" className='dark'>
                            (11) 3616 - 9000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                        <LinkExtermal href="tel:551136169000" className='dark'>
                            0800 774 2000
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                    </Box>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    backgroundColor: 'primary.main',
                    padding: '1rem 0',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                        maxWidth: '16rem',
                    }
                }}>
                    <Box sx={{
                        'button': {
                            color: 'white',
                            borderColor: 'white',
                            '&:hover': {
                                borderColor: 'white',
                                opacity: '.8'
                            }
                        }
                    }}>
                        <ButtonOutlined name='Voltar' onClick={() => {
                            isLinkRef && navigate('/faturas');
                            handleClick(false);
                        }} />
                    </Box>
                </Box>
            </BoxModal>
        </Modal>
    );
}